import React from "react";
import chatService from "../../../services/ChatService";

const FollowUpQuestions = ({ questions, chatId, brainId, onQuestionSent, setIsLoading }) => {
    const handleFollowUpClick = async (question) => {
        if (setIsLoading) setIsLoading(true);
        const [response, error] = await chatService.askQuestion(chatId, brainId, question);
        if (error) {
            console.error("Error sending follow-up question:", error);
        } else {
            onQuestionSent();
        }
        if (setIsLoading) setIsLoading(false);
    };

    return (
        <div className="follow-up-questions">
            <ul>
                {questions.slice(0, 3).map((question, index) => (
                    <li key={index}>
                        <button className="follow-up-button" onClick={() => handleFollowUpClick(question)}>
                            {question}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FollowUpQuestions;
